import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_GET_PUBLISHTRACK_BEGIN,
  APP_SETTING_GET_PUBLISHTRACK_SUCCESS,
  APP_SETTING_GET_PUBLISHTRACK_FAILURE,
  APP_SETTING_GET_PUBLISHTRACK_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function getPublishtrack(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_GET_PUBLISHTRACK_BEGIN,
    });
    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}publish/${projectId}`;
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_GET_PUBLISHTRACK_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_GET_PUBLISHTRACK_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetPublishtrackError() {
  return {
    type: APP_SETTING_GET_PUBLISHTRACK_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_GET_PUBLISHTRACK_BEGIN:
      return {
        ...state,
        getPublishtrackPending: true,
        getPublishtrackError: null,
      };

    case APP_SETTING_GET_PUBLISHTRACK_SUCCESS:
      return {
        ...state,
        getPublishtrackPending: false,
        getPublishtrackError: null,
        publishTrack: action.data.data,
      };

    case APP_SETTING_GET_PUBLISHTRACK_FAILURE:
      return {
        ...state,
        getPublishtrackPending: false,
        getPublishtrackError: action.data.error,
      };

    case APP_SETTING_GET_PUBLISHTRACK_DISMISS_ERROR:
      return {
        ...state,
        getPublishtrackError: null,
      };

    default:
      return state;
  }
}
